import { useFlags as useFlagsLD } from 'launchdarkly-react-client-sdk';

/**
 * Thin wrapper around `useFlags` from LaunchDarkly. Import from here instead
 * of directly from `launchdarkly-react-client-sdk` so flag values can be
 * overridden in a single place during local development/testing.
 */
export const useFlags = (): ReturnType<typeof useFlagsLD> => ({
  ...useFlagsLD(),
});
